{
  "version": 1,
  "asset_id": "d4ca0f4b-9dd3-492d-9295-1bee28d6f184",
  "project_id": "c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a",
  "url": "/__l5e/assets-v1/d4ca0f4b-9dd3-492d-9295-1bee28d6f184/x-logo.png",
  "r2_key": "a/v1/c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a/d4ca0f4b-9dd3-492d-9295-1bee28d6f184/x-logo.png",
  "original_filename": "x-logo.png",
  "size": 5372,
  "content_type": "image/png",
  "created_at": "2026-07-30T09:41:03Z"
}
